export default [
  {
    path: '/cadastro',
    name: 'cadastro',
    component: () => import('./index')
  }
]
